import { Constants } from '../_constants/shared.constants';

const initialState =  {loaderValue: true};
 function loaderReducer(state = initialState, action) {
  switch (action.type) {
    case   Constants.loader.LOADER_REQUESTER:
      console.log("data loader redux",action.data)
      return {
     
        loaderValue: action.data,
      };
  
    default:
        console.log("default data vessel redux",action.data)
      return state
  }
}

export default loaderReducer;